import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import axios from "axios";

function Formulario(props) {
  const [loading, setLoading] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [failedInvoices, setFailedInvoices] = useState([]); // Estado para las facturas fallidas

  const { handleSubmit, reset } = useForm();

  useEffect(() => {

    /*setFailedInvoices(
      [5922998, 5922999, 5923000, 5923001, 5923002, 5923003, 5923004, 5923005, 5923006, 5923007, 5923008, 5923009, 5923010, 5923011, 5923012, 5923013, 5923014, 5923015, 5923016, 5923017, 5923018, 5923019, 5923020, 5923021, 5923022, 5923023, 5923024, 5923025, 5923026, 5923027, 5923028, 5923029, 5923030, 5923031, 5923032, 5923033, 5923034, 5923035, 5923036, 5923037, 5923038, 5923039, 5923040, 5923041, 5923042, 5923043, 5923044, 5923045, 5923046, 5923047, 5923048, 5923049, 5923050, 5923051, 5923052, 5923053, 5923054, 5923055, 5923056, 5923057, 5923058, 5923059, 5923060,
        5922998, 5922999, 5923000, 5923001, 5923002, 5923003, 5923004, 5923005, 5923006, 5923007, 5923008, 5923009, 5923010, 5923011, 5923012, 5923013, 5923014, 5923015, 5923016, 5923017, 5923018, 5923019, 5923020, 5923021, 5923022, 5923023, 5923024, 5923025, 5923026, 5923027, 5923028, 5923029, 5923030, 5923031, 5923032, 5923033, 5923034, 5923035, 5923036, 5923037, 5923038, 5923039, 5923040, 5923041, 5923042, 5923043, 5923044, 5923045, 5923046, 5923047, 5923048, 5923049, 5923050, 5923051, 5923052, 5923053, 5923054, 5923055, 5923056, 5923057, 5923058, 5923059, 5923060,
        5922998, 5922999, 5923000, 5923001, 5923002, 5923003, 5923004, 5923005, 5923006, 5923007, 5923008, 5923009, 5923010, 5923011, 5923012, 5923013, 5923014, 5923015, 5923016, 5923017, 5923018, 5923019, 5923020, 5923021, 5923022, 5923023, 5923024, 5923025, 5923026, 5923027, 5923028, 5923029, 5923030, 5923031, 5923032, 5923033, 5923034, 5923035, 5923036, 5923037, 5923038, 5923039, 5923040, 5923041, 5923042, 5923043, 5923044, 5923045, 5923046, 5923047, 5923048, 5923049, 5923050, 5923051, 5923052, 5923053, 5923054, 5923055, 5923056, 5923057, 5923058, 5923059, 5923060,
        5922998, 5922999, 5923000, 5923001, 5923002, 5923003, 5923004, 5923005, 5923006, 5923007, 5923008, 5923009, 5923010, 5923011, 5923012, 5923013, 5923014, 5923015, 5923016, 5923017, 5923018, 5923019, 5923020, 5923021, 5923022, 5923023, 5923024, 5923025, 5923026, 5923027, 5923028, 5923029, 5923030, 5923031, 5923032, 5923033, 5923034, 5923035, 5923036, 5923037, 5923038, 5923039, 5923040, 5923041, 5923042, 5923043, 5923044, 5923045, 5923046, 5923047, 5923048, 5923049, 5923050, 5923051, 5923052, 5923053, 5923054, 5923055, 5923056, 5923057, 5923058, 5923059, 5923060,
        5922998, 5922999, 5923000, 5923001, 5923002, 5923003, 5923004, 5923005, 5923006, 5923007, 5923008, 5923009, 5923010, 5923011, 5923012, 5923013, 5923014, 5923015, 5923016, 5923017, 5923018, 5923019, 5923020, 5923021, 5923022, 5923023, 5923024, 5923025, 5923026, 5923027, 5923028, 5923029, 5923030, 5923031, 5923032, 5923033, 5923034, 5923035, 5923036, 5923037, 5923038, 5923039, 5923040, 5923041, 5923042, 5923043, 5923044, 5923045, 5923046, 5923047, 5923048, 5923049, 5923050, 5923051, 5923052, 5923053, 5923054, 5923055, 5923056, 5923057, 5923058, 5923059, 5923060
      ] || []);*/
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "text/plain") {
      setSelectedFile(file);
    } else {
      toast.error("Por favor, cargue un archivo de texto plano (.txt).");
      setSelectedFile(null);
    }
  };

  const parseFileToJson = async () => {
    if (!selectedFile) {
      toast.error("No se ha seleccionado ningún archivo.");
      return null;
    }

    try {
      const fileContent = await selectedFile.text();
      const numbers = fileContent
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line && !isNaN(line))
        .map(Number);

      if (numbers.length === 0) {
        toast.error("El archivo no contiene números válidos.");
        return null;
      }

      return { fileData: numbers };
    } catch (error) {
      toast.error("Hubo un error al procesar el archivo.");
      return null;
    }
  };

  const onSubmit = async () => 
  {
    setLoading(true);
    const data = await parseFileToJson();
    if (!data) {
      setLoading(false);
      return;
    }

    try 
    {
      console.log(data);
      
      const result = await axios.post(
        `https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/outsource/bmanual/uploadFile`,
        data,
        {
          timeout: 300000,
        }
      );
      setLoading(false);
      console.log(result.data);
      
      if (result.data.status) {
        toast.success(result.data.body.message);
        reset();
        setSelectedFile(null);
        setFileData(null);
        setFailedInvoices([]);
        const { data } = result.data.body 
        setFailedInvoices(data || []);
      } else {
        toast.error(result.data.body.message);
      }
    } catch (error) {
      toast.error("Algo salió mal al enviar los datos.");
      setLoading(false);
    }
  };

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
        <h1 className="formulario">Cargue Masivamente de facturas</h1>

        <Row className="contenedorF-Filtrado mbottom-20">
          <Col xs={12}>
            <Form.Group>
              <Form.Label className="texto-label">
                Cargar Archivo Plano (.txt)
              </Form.Label>
              <Form.Control
                type="file"
                accept=".txt"
                onChange={handleFileChange}
              />
            </Form.Group>
            <Form.Label className="texto-label">
                Observación : Realizar cargas por lotes de 200 registros maximo.
            </Form.Label>
          </Col>
        </Row>

        <Row className="mtop-10">
          <Col xs={12}>
            <Button
              type="submit"
              variant="primary"
              className="btn btn-primary boton"
              style={{ width: "100%" }}
              disabled={!selectedFile}
            >
              Cargar
            </Button>
          </Col>
        </Row>

        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
      </form>


      {failedInvoices.length > 0 && (
        <div className="failed-invoices">
          <h6>Facturas que no fueron cargadas:</h6>
          <p>{failedInvoices.join(", ")}</p>
        </div>
      )}

      <style jsx>{`
        .centered-input {
          text-align: center;
        }
        .failed-invoices {
          background-color: #f8d7da;
          border: 1px solid #f5c6cb;
          color: #721c24;
          padding: 20px;
          margin-top: 20px;
          border-radius: 5px;
          max-height: 200px; /* Altura máxima del contenedor */
          overflow-y: auto; /* Habilitar scroll cuando el contenido sea muy largo */
        }
      `}</style>
    </>
  );
}

export default Formulario;
